import { lazy, Suspense } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { AuthProvider } from './contexts/AuthContext';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import About from './pages/About';
import Schools from './pages/Schools';
import SchoolDetails from './pages/SchoolDetails';
import CourseDetails from './pages/CourseDetails';
import Contact from './pages/Contact';

const Consultation = lazy(() => import('./pages/Consultation'));
import FAQ from './pages/FAQ';
import Accommodation from './pages/Accommodation';
import Workshops from './pages/Workshops';
import Privacy from './pages/Privacy';
import Terms from './pages/Terms';
import Blogs from './pages/Blogs';
import BlogPost from './pages/BlogPost';
import VideoTestimonials from './pages/VideoTestimonials';
import Login from './pages/Login';
import Signup from './pages/Signup';
import VerifyEmail from './pages/VerifyEmail';
import Profile from './pages/Profile';
import Bookings from './pages/Bookings';
import BookingDetails from './pages/BookingDetails';
import MyConsultations from './pages/MyConsultations';
import Messages from './pages/Messages';
import ScrollToTop from './components/ScrollToTop';
import EmailVerificationGuard from './components/EmailVerificationGuard';
import { ProtectedRoute } from './components/ProtectedRoute';

function App() {
  return (
    <HelmetProvider>
      <AuthProvider>
        <Router>
          <div className="min-h-screen bg-background overflow-x-hidden">
            <ScrollToTop />
            <Navbar />
            <main className="w-full">
              <EmailVerificationGuard>
                <Routes>
                  <Route path="/" element={<Schools />} />
                  <Route path="/about" element={<About />} />
                  <Route path="/schools/:slug" element={<SchoolDetails />} />
                  <Route path="/schools/:slug/:courseSlug" element={<CourseDetails />} />
                  <Route path="/consultation" element={<Suspense fallback={<div className="min-h-[60vh] flex items-center justify-center"><div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary" /></div>}><Consultation /></Suspense>} />
                  <Route path="/contact" element={<Contact />} />
                  <Route path="/faq" element={<FAQ />} />
                  <Route path="/accommodation" element={<Accommodation />} />
                  <Route path="/workshops" element={<Workshops />} />
                  <Route path="/privacy" element={<Privacy />} />
                  <Route path="/terms" element={<Terms />} />
                  <Route path="/blogs" element={<Blogs />} />
                  <Route path="/blog/:slug" element={<BlogPost />} />
                  <Route path="/testimonials" element={<VideoTestimonials />} />
                  <Route path="/login" element={<Login />} />
                  <Route path="/signup" element={<Signup />} />
                  <Route path="/verify-email" element={<VerifyEmail />} />
                  <Route path="/profile" element={<ProtectedRoute><Profile /></ProtectedRoute>} />
                  <Route path="/bookings" element={<ProtectedRoute><Bookings /></ProtectedRoute>} />
                  <Route path="/bookings/:id" element={<ProtectedRoute><BookingDetails /></ProtectedRoute>} />
                  <Route path="/messages" element={<ProtectedRoute><Messages /></ProtectedRoute>} />
                  <Route path="/my-consultations" element={<ProtectedRoute><MyConsultations /></ProtectedRoute>} />
                </Routes>
              </EmailVerificationGuard>
            </main>
            <Footer />
          </div>
        </Router>
      </AuthProvider>
    </HelmetProvider>
  );
}

export default App;
